import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45cd1261"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid justify-content-end" }
const _hoisted_2 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center w-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2 p-dialog-title" }, "下書き保存しました")
], -1))
const _hoisted_4 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/warning-logo.png",
    alt: "Warning Logo",
    class: "warning-logo mr-4 ml-2"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "保存されていない設定情報は破棄されます。破棄しますか？")
], -1))
const _hoisted_6 = { class: "grid mt-5 mb-5 justify-content-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center w-100" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "配信設定が完了しました。")
], -1))
const _hoisted_8 = { class: "grid mt-5 mb-5 justify-content-center" }

import { ref, onBeforeMount, onBeforeUnmount, onMounted } from "vue";
import DeliverySetting from "./DeliverySetting.vue";
import TargetSetting from "./TargetSetting.vue";
import MessageSetting from "./MessageSetting.vue";
import BasicSetting from "./BasicSetting.vue";
import { get, set } from "@vueuse/core";
import DistributionGroupService from "@/clinic/services/distribution_group_service";
import Toast from "primevue/toast";
import { onBeforeRouteLeave, useRouter } from "vue-router";
import { useToast } from "primevue/usetoast";
import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import { useStore } from "vuex";
import ApiRouterConstants from "@/clinic/constants/api.router.constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'FinalSetting',
  props: {
    isEdit: { type: Boolean },
    distributionGroupId: null,
    basicInformation: null,
    targetInformation: null,
    deliverySetting: null,
    messageSetting: null
  },
  emits: ["resourcesFn", "backWithFinalSetting", "editSuccess", "backFromMessageSetting"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  isEdit: boolean;
  distributionGroupId: any;
  basicInformation: any;
  targetInformation: any;
  deliverySetting: any;
  messageSetting: any;
};


const toast = useToast();
const router = useRouter();
const saveDraftVisible = ref(false);
const clinicId = ref("");
const broadcastSuccessVisible = ref(false);
const hasPermissionRedirect = ref(false);
const warningRedirectPage = ref(false);
const nextRoute = ref(null);

const store = useStore();

const back = (step: number) => {
  emits("backWithFinalSetting", step, true);
};

const backFromMessageSetting = (step, currentOrderMessage) => {
  emits("backFromMessageSetting", step, currentOrderMessage);
};

const handleError = promise => {
  return promise.then(data => [undefined, data]).catch(error => [error, undefined]);
};
const saveDraft = async () => {
  const params = { clinic_id: clinicId.value };
  const body = { status: "draft" };
  const [errorSaveDraft, data] = await handleError(
    DistributionGroupService.changeStatus(props.distributionGroupId, params, body)
  );
  if (errorSaveDraft) {
    notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください");
  } else {
    saveDraftVisible.value = true;
  }
};
const broadcast = async () => {
  const params = { clinic_id: clinicId.value };
  const [errorBroadCast, data] = await handleError(
    DistributionGroupService.broadcast(props.distributionGroupId, params)
  );
  if (errorBroadCast) {
    notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください");
  } else {
    broadcastSuccessVisible.value = true;
  }
};

const destroyWhenRedirect = async () => {
  try {
    if (!props.isEdit) {
      await DistributionGroupService.destroy(props.distributionGroupId);
    }
    set(hasPermissionRedirect, true);
    set(warningRedirectPage, false);
    if (get(nextRoute)) {
      router.push(nextRoute.value);
    }
    window.removeEventListener("beforeunload", handleBeforeUnload);
  } catch (error) {
    console.log("error", error);
  }
};

const returnNewGroupPage = () => {
  emits("editSuccess");
};

const returnTop = () => {
  set(hasPermissionRedirect, true);
  RouterUtils.goTo(RouterConstants.DISTRIBUTION_ROUTINE_GROUP_ROUTER_NAME);
};

const returnCurrentPage = () => {
  saveDraftVisible.value = false;
};

const loadClinicInfo = async () => {
  const storeClinicId = await store.dispatch("authClient/getClinicIdCookie");
  clinicId.value = storeClinicId;
};

const handleBeforeUnload = event => {
  event.preventDefault();
  event.returnValue = "";
  window.addEventListener("unload", async function () {
    if (!props.isEdit) {
      const url = `${ApiRouterConstants.API_DISTRIBUTION_GROUPS}/${props.distributionGroupId}`;
      await fetch(url, { method: "DELETE", keepalive: true });
    }
  });
};

const saveDraftWhenRedirect = async () => {
  const params = { clinic_id: clinicId.value };
  const body = { status: "draft" };

  const [errorSaveDraft, data] = await handleError(
    DistributionGroupService.changeStatus(props.distributionGroupId, params, body)
  );

  if (errorSaveDraft) {
    notityErrorMsg(toast, "何かが間違っています。後でもう一度試してください");
  }

  saveDraftVisible.value = false;
  set(hasPermissionRedirect, true);
  if (get(nextRoute)) {
    router.push(nextRoute.value);
  }
};

onBeforeRouteLeave((to, from, next) => {
  if (get(hasPermissionRedirect)) {
    next();
  } else {
    set(warningRedirectPage, true);
    set(nextRoute, to.fullPath);
    next(false);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener("beforeunload", handleBeforeUnload);
});

onMounted(() => {
  window.addEventListener("beforeunload", handleBeforeUnload);
  document.getElementById("step-setting").scrollIntoView();
});

onBeforeMount(async () => {
  await loadClinicInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BasicSetting, {
      basicInformation: props.basicInformation,
      finalSetting: true,
      isEdit: props.isEdit
    }, null, 8, ["basicInformation", "isEdit"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Button, {
        class: "col-2 create-btn ml-5 border-round-lg",
        label: "編集画面に戻る",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (back(1)))
      })
    ]),
    _createVNode(TargetSetting, {
      distributionGroupId: __props.distributionGroupId,
      targetInformation: __props.targetInformation,
      finalSetting: true,
      onBackFromFinalSetting: back,
      isEdit: props.isEdit
    }, null, 8, ["distributionGroupId", "targetInformation", "isEdit"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.messageSetting, (message, index) => {
      return (_openBlock(), _createBlock(MessageSetting, {
        key: index,
        deliverySetting: __props.deliverySetting,
        messageSetting: __props.messageSetting,
        finalSetting: true,
        isDisplayHeader: message.position === 1 ? true : false,
        isPickedTotalMessage: true,
        orderMessage: message.position,
        onBackFromFinalSetting: backFromMessageSetting,
        isEdit: props.isEdit
      }, null, 8, ["deliverySetting", "messageSetting", "isDisplayHeader", "orderMessage", "isEdit"]))
    }), 128)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Button, {
        class: "col-3 temp-save-btn ml-5 border-round-lg",
        label: "下書き保存",
        onClick: saveDraft
      }),
      _createVNode(_component_Button, {
        class: "col-3 create-btn ml-5 border-round-lg",
        label: "配信設定完了",
        onClick: broadcast
      })
    ]),
    _createVNode(_component_Dialog, {
      visible: saveDraftVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((saveDraftVisible).value = $event)),
      modal: "",
      header: '下書き保存しました',
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_3
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            class: "col-3 black-btn ml-5 border-round-lg",
            label: "TOPに戻る",
            onClick: returnTop
          }),
          _createVNode(_component_Button, {
            class: "col-3 create-btn ml-5 border-round-lg",
            label: "作成を続ける",
            onClick: returnCurrentPage
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: warningRedirectPage.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((warningRedirectPage).value = $event)),
      modal: "",
      style: { width: '720px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_5
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Button, {
            class: "col-3 temp-save-btn mr-5 border-round-lg",
            label: "下書き保存",
            onClick: saveDraftWhenRedirect
          }),
          _createVNode(_component_Button, {
            class: "col-3 black-btn mr-5 border-round-lg",
            label: "戻る",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (warningRedirectPage.value = false))
          }),
          _createVNode(_component_Button, {
            class: "col-3 confirm-delete-btn border-round-lg",
            label: "破棄する",
            onClick: destroyWhenRedirect
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: broadcastSuccessVisible.value,
      "onUpdate:visible": [
        _cache[4] || (_cache[4] = ($event: any) => ((broadcastSuccessVisible).value = $event)),
        returnTop
      ],
      modal: "",
      style: { width: '550px' },
      class: "mx-5 dialog-note border-0",
      draggable: false
    }, {
      header: _withCtx(() => [
        _hoisted_7
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Button, {
            class: "col-4 black-btn ml-5 border-round-lg",
            label: "配信TOPへ戻る",
            onClick: returnTop
          }),
          _createVNode(_component_Button, {
            class: "col-4 create-btn ml-5 border-round-lg",
            label: "配信グループ新規作成",
            onClick: returnNewGroupPage
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})